import { render } from "./TreeNodeActions.vue?vue&type=template&id=0b6f9bd8&scoped=true"
import script from "./TreeNodeActions.vue?vue&type=script&lang=js"
export * from "./TreeNodeActions.vue?vue&type=script&lang=js"

import "./TreeNodeActions.vue?vue&type=style&index=0&id=0b6f9bd8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b6f9bd8"],['__file',"src/views/FAQManagement/components/TreeNodeActions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b6f9bd8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b6f9bd8', __exports__)) {
    api.reload('0b6f9bd8', __exports__)
  }
  
  module.hot.accept("./TreeNodeActions.vue?vue&type=template&id=0b6f9bd8&scoped=true", () => {
    api.rerender('0b6f9bd8', render)
  })

}


export default __exports__